import { render } from "./Production.vue?vue&type=template&id=3d478772"
import script from "./Production.vue?vue&type=script&lang=js"
export * from "./Production.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__